import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

export type LevelBadgeSize = 'sm' | 'md';

export interface LevelBadgeProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
    level: number;
    size?: LevelBadgeSize;
}

const SIZE_CLASSES: Record<LevelBadgeSize, string> = {
    sm: 'min-w-[22px] h-[22px] px-1.5 text-[11px]',
    md: 'min-w-[30px] h-[30px] px-2 text-[14px]',
};

const BASE_CLASSES =
    'inline-flex items-center justify-center rounded-full bg-surface-raised border-[1.5px] border-[color:var(--zone-accent)] font-extrabold text-content-primary shadow-e1';

export const LevelBadge = forwardRef<HTMLSpanElement, LevelBadgeProps>(function LevelBadge(
    { level, size = 'md', className, ...rest },
    ref,
) {
    return (
        <span ref={ref} className={cn(BASE_CLASSES, SIZE_CLASSES[size], className)} {...rest}>
            {level}
        </span>
    );
});

export default LevelBadge;
